export const QUERY_KEYS = {
  SETTING: {
    BANNERS: {
      INDEX: ["banners"],
      List: ["banners", "list"],
      ListSet: ["banners", "list", "set"],
    },
  },

  DUMMY: {
    SEARCH: ["bummy", "searchTags"],
  },

  EVENT: {
    INDEX: ["event"],
  },

  SITE_CONFING: {
    INDEX: ["siteConfig", "prototype"],
  },

  USERINFO: {
    INDEX: ["userInfoList"],
  },

  PRODUCTS: {
    LIST: {
      PAGINATION: (page) => ["products", "pagination", page],
    },

    BESTPRODUCTS: {
      INDEX: ["products", "best"],
      DETAIL: ["products", "best", "detail"],
    },

    BRAND: {
      INDEX: (pcodeList) => ["brandProducts", pcodeList],
    },
  },

  ESG: {
    BOARDS: {
      INDEX: (boardName) => ["boards", "list", boardName],
    },
  },

  CUSTOMIZING: {
    //카테고리
    CATEGORY: {
      INDEX: ["itemDetail"],
      DETAIL: (id) => ["itemDetail", "detail", id],
    },
    //장바구니
    BASKETS: {
      INDEX: ["customBasketList"],
    },
    GALLERY: {
      INDEX: ["customGalleryList"],
    },

    //판촉물
    PROMOTION: {
      INDEX: ["promotionList"],
      DETAIL: (id) => ["promotionList", "detail", id],
    },
    //시제품
    PROTOTYPE: {
      INDEX: ["prototypeList"],
      DETAIL: (id) => ["prototypeList", "detail", id],
    },
    //소량인쇄
    PRINT: {
      FAQ: ["faq"],
      CART: ["print", "cart"],
      PRODUCTS: ["print", "products"],
    },
  },
};
